/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Status of the rule
 */
export type IncidentRuleStatus = (typeof IncidentRuleStatus)[keyof typeof IncidentRuleStatus];

export const IncidentRuleStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  ADMIN_DISABLED: 'admin_disabled',
} as const;
